// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"cc","reportCardBox":"cc","report-img-wrap":"cd","reportImgWrap":"cd","report-title":"ce","reportTitle":"ce","report-date":"cf","reportDate":"cf"};